import React, { ComponentProps } from 'react';
import styled from 'styled-components';

import { SmallTile } from 'components/Tile';
import { colors, transition } from 'theme';

export const SlimSearchTile = styled(
  ({ children, ...props }: ComponentProps<typeof SmallTile>) => (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <SmallTile {...props}>{children}</SmallTile>
  )
)`
  overflow: visible;
  ${(props) => {
    if (props.disabled) {
      return `
        background: transparent;
        box-shadow: 0 0 0 1px ${colors.aluminum};
      `;
    }

    return `
      cursor: pointer;
      border-top: 4px solid ${colors.waterBlue};
      transition: all ${transition};
      
      &:hover,
      &:focus {
        border-color: ${colors.turtleGreen};
      }
    `;
  }}
`;
